<template>
  <div>
    <div id="main-page">
      <div id="header">
        <img src="@/assets/theme/header.png">
      </div>
      <div id="content">
        <div id="c-content">
          <!--<div class="text-center mb-2">
            <img src="@/assets/theme/b1.jpg" class="banner">
          </div>-->
          <div>
            <VueSlickCarousel :arrows="false" :dots="false" :autoplay="true" :autoplaySpeed="3000">
              <div><img src="@/assets/theme/b1.jpg" class="banner"></div>
              <div><img src="@/assets/theme/b2.png" class="banner"></div>
              <div><img src="@/assets/theme/b3.jpg" class="banner"></div>
              <div><img src="@/assets/theme/b4.jpg" class="banner"></div>
            </VueSlickCarousel>
          </div>
          <TodayResult />
          <div class="text-center mt-3">
            <img src="@/assets/theme/b5.jpg" class="banner">
          </div>
          <HistoryResults />
          <!--<div class="text-center mt-3">
            <img src="@/assets/theme/WhatsApp-Image-2020-05-27-at-5.13.00-PM.jpeg" class="banner">
          </div>-->
          <div class="text-center mt-3">
            <img src="@/assets/theme/b6.png" class="banner">
          </div>
        </div>
        <div id="r-content">
          <div class="box-banner">
            <img src="@/assets/theme/b9.png" class="banner">
          </div>
          <div class="box-banner">
            <img src="@/assets/theme/b7.jpg" class="banner">
          </div>
          <div class="news">
            <!--<iframe src="https://kaotoday.com/category/daily/" scrolling="no"></iframe>-->
          </div>
          <div class="box-banner">
            <img src="@/assets/theme/167010.jpg" class="banner">
          </div>
          <div class="box-banner">
            <img src="@/assets/theme/banner06.png" class="banner">
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="f-banner">
        <img src="@/assets/theme/b8.png">
      </div>
      <div id="footer">
        Copyright {{y}} © laosextra.com
      </div>
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

import TodayResult from './components/TodayResult.vue'
import HistoryResults from './components/HistoryResults.vue'

import LottoService from "@/services/lottoService"

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: {
    TodayResult,
    HistoryResults,
    VueSlickCarousel
  },
  data() {
    return {
      timeNow: moment().format("HH:mm:ss"),
      timeInterval: null,
      News: []
    }
  },
  computed: {
    TopNews() {
      return this.News.slice(0, 3)
    },
    y() {
      return moment().format("Y")
    }
  },
  methods: {
    getNews() {
      LottoService.getNews().then((response)=>{
        if(response.result === 'success') {
          this.News = response.data
        }
      })
    }
  },
  created() {
    //this.getNews()
    this.timeInterval = setInterval(() => {
      this.timeNow = moment().format("HH:mm:ss")
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
  },
  /*mounted() {
    this.$ga.page('/')
  },*/
  filters: {
    date(param) {
      return moment(param).format("DD/MM/YYYY HH:MM")
    }
  }
}

</script>
<style lang="scss">
body {
  //background-color: #000000;
  font-family: 'Dhyana', sans-serif;
  //font-family: "Roboto Condensed", Helvetica, Arial, Verdana, sans-serif;
  //font-family: "Open Sans", Helvetica, Arial, sans-serif,'Noto Serif Lao', 'dashicons' !important;
  //background: #fff url('../assets/theme/bg.png') repeat-x left 0;
}

.clearfix {
  clear: both;
}

.banner {
  max-width: 100%;
}

#main-page {
  width: 1100px;
  margin: 0 auto;
  background-color: #FFF;
  padding-bottom: 0px;

  #header {
    background-image: url('../assets/theme/header-bg.png');
    background-size: cover;
    border-bottom: 4px solid #B00000;
    border-top: 15px solid #011E3A;
    margin-bottom: 10px;
    img {
      max-width: 90%;
    }
  }

  #content {
    padding: 0px;
    margin: 0px;

    .box-banner {
      margin-bottom: 5px;
      text-align: center;

      .banner {
        width: 100%;
        max-width: 100%;
      }
    }

    #c-content {
      float: left;
      width: 700px;
      padding: 0px;
      //margin: 10px 5px;

      .box-news {
        margin-top: 15px;
        margin-bottom: 10px;

        .box-list-news {
          border-bottom: 1px dotted #e2e2e2;
          padding: 10px 0 5px;

          h6.title-news-top {
            font-weight: bold;

            a {
              color: #0077cc;
            }
            a:hover {
              color: #000000;
            }
            a:visited {
              color: #0077cc;
            }
          }

          .news-date {
            font-size: 11px;
            margin: 5px 0;
          }

          .more {
            a {
              color: #0077cc;
              font-weight: bold;
              float: right;
              background: transparent url('../assets/theme/i-more.jpg') no-repeat right 4px;
              font-weight: bold;
              font-style: italic;
              font-size: 12px;
              display: block;
              padding-right: 15px;
            }
            a:hover {
              color: #000;
            }
            a:visited {
              color: #0077cc;
            }
          }
        }
      }
    }

    #l-content {
      float: left;
      width: 250px;
      max-width: 100%;
      padding-right: 5px;

      .news {
        overflow: hidden;
        iframe {
          width: 100%;
          border:0;
          height:1400px;
          overflow:hidden;
          pointer-events:none;
          margin-top:-170px;
        }
      }
    }

    #r-content {
      float: left;
      width: 385px;
      max-width: 100%;
      //margin: 10px 5px;
      padding: 0px;
      margin-left: 15px;

      .news {
        overflow: hidden;
        iframe {
          width: 100%;
          border:0;
          height:1450px;
          overflow:hidden;
          pointer-events:none;
          margin-top:-230px;
        }
      }

      .box-news {
        margin-top: 10px;

        .box-title {
          background: #fff url('../assets/theme/news-header.png') no-repeat left 0;
          clear: both;
          overflow: hidden;
          height: 35px;
          padding-left: 0;
          display: block;
          border: 0;

          border-top: 0px #fff solid;
          border: 0 solid #ccc;
          border-width: 1px 1px 0 0;
          border-bottom: 1px solid #CCCCCC;

          h5 {
            line-height: 32px;
            padding-left: 10px;
            height: 24px;
            color: #07c;
            font-weight: bold;
            float: left;
          }

          .social-button {
            float: right;
            padding-right: 10px;
            padding-top: 3px;
            font-size: 18px;

            .fa-facebook-f {
              color: #0077cc;
            }

            .fa-youtube {
              color: red;
            }
          }
        }

        .box-content {
          background-image: none;
          border-top: 0px #fff solid;
          border: 0 solid #ccc;
          border-width: 0 1px 0 1px;
          border-bottom: 1px solid #CCCCCC;

          .top-news {
            overflow: hidden;
            clear: both;
            padding: 10px;

            li {
              overflow: hidden;
              display: block;
              margin-bottom: 5px;
              padding-bottom: 5px;
              padding-left: 15px;
              line-height: 21px;
              font-size: 13px;
              height: auto;
              border-bottom: 1px dotted #e2e2e2;
              background: url('../assets/theme/icon-story.gif') no-repeat scroll left 3px transparent;

              a {
                color: #0077cc;
                text-decoration: none;
              }

              a:visited {
                color: #0077cc;
                text-decoration: none;
              }

              a:hover {
                color: #000000;
              }

              .time-news {
                font-size: 11px;
                display: inline;
              }
            }
          }
        }
      }
    }
  }

  .f-banner {
    padding: 0px;
    img {
      width: 100%;
      max-width: 100%;
    }
  }
}

#footer {
  margin-top: 10px;
  background: #011E3A;
  overflow: hidden;
  color: #fff;
  padding: 15px 0;
  text-align: center;
  margin-bottom: 0px;
}

@media (max-width: 768px) {
  #main-page {
    width: 100%;
    padding-bottom: 0px;

    #header {

      /*.box-logo {
        width: 100%;
        height: auto;
        float: none;
        text-align: center;
      }
      .box-banner {
        width: 100%;
        float: none;

        .banner {
          width: 100%;
          height: auto;
        }
      }*/
    }

    #content {
      margin-top: 5px;
      #l-content {
        float: none;
        width: 100%;
        display: none;

        .box-news {
          .box-title {
            background: none;
            border: 0px solid #ccc;
            border-width: 1px 1px 0 1px;
            border-bottom: 1px solid #CCCCCC;
          }
        }
      }
      #c-content {
        float: none;
        width: 100%;
        padding: 0px;
        margin: 0px;

        .box-news {
          margin-top: 5px;
        }
      }
      #r-content {
        float: none;
        width: 100%;
        margin: 0px;

        .box-banner {
          margin-bottom: 5px;
          text-align: center;

          .banner {
            width: 100%;
            max-width: 100%;
          }
        }

        .box-news {

        }
      }
    }
  }

  #footer {
    margin-top: 0px;
  }
}
</style>
